import { connect } from "react-redux";
import QuestionData from "assets/data/QuestionData";
// Component
import BaseWord from "components/CreateSurvey/BaseWord";
// Action
import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { showSnackbar } from "redux/modules/snackbar";
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  setErrors,
  initBaseWord,
  setBaseWordInfo,
  setBaseWordLocale,
  setBaseWordEdit,
  setBaseWordSelectedId,
  updateBaseWordItems,
  changeBaseWordItem,
  changeBaseWordSelection,
  openReplaceModal,
  openPreviewModal,
  discardBaseWord
} from "redux/modules/createSurvey";
// Utils
import history from "utils/history";
import { convertLocaleKeyToName } from "utils/formatter";
import api from "api";

const mapStateToProps = state => ({
  survey: state.createSurvey.survey,
  baseWord: state.createSurvey.baseWord,
  locales: state.createSurvey.locales,
  baseInfo: state.createSurvey.baseInfo,
  errors: state.createSurvey.errors
});

export const validate = (baseInfo, baseWord) => {
  const errors = [];
  baseInfo.useLocales.forEach(locale => {
    baseWord.items[locale].forEach(item => {
      if (item.content === "") {
        errors.push(
          `${convertLocaleKeyToName(locale)}: Q${
            item.id
          }の設問文を入力してください。`
        );
      }
    });
  });

  return errors;
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  init: () => {
    dispatch(initBaseWord());
  },
  fetchSurveyDetail: () => {
    if (ownProps.match.path.indexOf("create_survey") > -1) {
      return;
    }
    const { id } = ownProps.match.params;
    api
      .get(`survey_detail/${id}/edit_base_word`)
      .then(res => dispatch(setBaseWordInfo(res)))
      .catch(error => dispatch(openErrorDialog(error)));
  },
  handleUpdate: props => {
    const { survey, baseInfo, baseWord } = props;
    const errors = validate(baseInfo, baseWord);
    dispatch(setErrors(errors));

    if (errors.length > 0) {
      window.scroll(0, 0);
      return;
    }
    const dialogData = {
      title: "確認",
      contentText: "基本設問文言を変更します。よろしいですか？",
      btnLabel: "更新",
      handleClick: () => {
        const params = {
          survey: survey.toObject(),
          baseInfo,
          baseWord,
          check_flg: 0
        };
        const { id } = ownProps.match.params;
        if (!baseWord.isEdit) {
          baseInfo.useLocales.forEach(useLocale => {
            params.baseWord.items[useLocale] = JSON.parse(
              JSON.stringify(QuestionData.QUESTIONS[useLocale])
            );
          });
        }
        api
          .post(`update_base_word/${id}`, params)
          .then(res => {
            dispatch(closeConfirmDialog());

            if (res.errors) {
              dispatch(openErrorDialog(res.errors));
            } else {
              dispatch(showSnackbar("基本設問文言を変更しました。"));
              ownProps.history.goBack();
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };
    dispatch(openConfirmDialog(dialogData));
  },
  handlePrev: () => {
    dispatch(setErrors([]));
    ownProps.history.goBack();
  },
  handleNext: props => {
    const { baseInfo, baseWord } = props;
    const errors = validate(baseInfo, baseWord);
    dispatch(setErrors(errors));
    if (errors.length > 0) {
      window.scroll(0, 0);
      return;
    }

    const { id } = ownProps.match.params;
    history.push(`/create_survey/${id}/additions`, ownProps);
  },
  changeLocale: (event, localeNo) => {
    dispatch(setBaseWordLocale(localeNo));
  },
  checked: event => {
    dispatch(setBaseWordEdit(event.target.checked));
  },
  selectItem: id => {
    dispatch(setBaseWordSelectedId(id));
  },
  updateItems: (item, index, atIndex) => {
    dispatch(updateBaseWordItems(item, index, atIndex));
  },
  changeItem: (key, value) => {
    dispatch(changeBaseWordItem(key, value));
  },
  openReplaceModal: () => {
    dispatch(openReplaceModal());
  },
  openPreviewModal: (localeNo, selectedItemId, items) => {
    dispatch(openPreviewModal(localeNo, selectedItemId, items));
  },
  handlePrevItem: () => {
    dispatch(changeBaseWordSelection(-1));
  },
  handleNextItem: () => {
    dispatch(changeBaseWordSelection(1));
  },
  discard: baseInfo => {
    const dialogData = {
      title: "確認",
      contentText:
        "基本設問文言の設定を全て編集前の状態に戻します。よろしいですか？",
      btnLabel: "実行",
      handleClick: () => {
        if (baseInfo.baseSurveyId) {
          api
            .get(`discard_base_word/${baseInfo.baseSurveyId}`)
            .then(res => {
              if (res.errors) {
                dispatch(openErrorDialog(res.errors));
              } else {
                dispatch(discardBaseWord(res));
                dispatch(closeConfirmDialog());
              }
            })
            .catch(error => dispatch(openErrorDialog(error)));
        } else {
          dispatch(discardBaseWord());
          dispatch(closeConfirmDialog());
        }
      }
    };
    dispatch(openConfirmDialog(dialogData));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(BaseWord);



// WEBPACK FOOTER //
// ./src/containers/CreateSurvey/BaseWord/index.js